export enum SentryEventEnum {
  AuthError = 'auth_error',
}
